import { TfiHeartBroken } from "react-icons/tfi";
import BtnTemplate from "../BtnTemplate";

import { useLocation, useNavigate } from "react-router-dom";

import Tooltip from "../../ToolTip";

const Diagnosis = ({ open = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const id = "diagnosis-tooltip";

  return (
    <div data-tip data-for={id} className="w-full">
      <BtnTemplate
        label={"Diagnosis"}
        open={open}
        active={location.pathname.includes("dashboard/diagnosis")}
        click={() => navigate("diagnosis")}
      >
        <TfiHeartBroken />
      </BtnTemplate>
      <Tooltip id={id} txt1="Diagnosis Management" txt2="in one spot">
        <TfiHeartBroken />
      </Tooltip>
    </div>
  );
};

export default Diagnosis;
